module.exports = __webpack_public_path__ + "static/onboard-a9912502286b7e881181c3c61d7b3258.png";